// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { selectHasOwnerOnly, selectCartUUID } from '@gandi/cart';
import { createOneOrganization } from '@gandi/redux-organization';
import { selectCurrencies } from '@gandi/redux-places';

import { withTranslator } from '@gandi/translate';

import { actions } from 'gandi.react-form';

import { withLogger } from 'gandi.redux-logger';

import { withRouter } from 'src/helpers/withRouter';
import type { FullState, MapDispatchToProps } from 'src/types';

import AccountForm from '../components/Form/AccountForm';

import Presenter, {
  type DispatchProps,
  type StateProps,
} from './components/Presenter';

const mapStateToProps = (state: FullState): StateProps => ({
  cartId: selectCartUUID(state),
  // $FlowFixMe[incompatible-return]
  currencies: selectCurrencies(state),
  hasOwnerOnly: selectHasOwnerOnly(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps> = {
  createOneOrganization,
  destroyForm: actions.destroy.bind(null, AccountForm.FORM_ID),
};

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  withPageMeta(args => ({
    title: args.__('Create an organization - Gandi.net'),
  })),
  withRouter,
  withLogger('Cart/Configure/Account/Create'),
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{}>);
